import tippy from 'tippy.js';

export const initTooltip = () => {
	const tooltipElements = document.querySelectorAll('[data-tooltip]');
	tooltipElements.forEach((element) => {
		const tooltipText = element.getAttribute('data-tooltip');
		const theme = element.getAttribute('data-tooltip-theme');

		if (tooltipText) {
			tippy(element, {
				content: tooltipText,
				placement: 'top',
				arrow: true,
				animation: 'fade',
				theme: theme ? theme : 'erd',
			});
		}
	});
};
